/**
 * The statement a drawer form is about to run, one click away at the foot of
 * the form.
 */
import { useState } from 'react';
import { ChevronDownIcon } from '../../components/ds/icons';

export const StatementDisclosure = ({ sql, emptyText }: { sql: string, emptyText: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      <button
        type="button"
        onClick={() => setIsOpen(open => !open)}
        aria-expanded={isOpen}
        className="b4-focus self-start inline-flex items-center gap-1.5 rounded-control font-inter text-ds-125 font-semibold text-action-soft hover:text-white transition-colors duration-[120ms]"
      >
        <ChevronDownIcon size={14} className={`transition-transform duration-[120ms] ${isOpen ? '' : '-rotate-90'}`} />
        {isOpen ? 'Hide SQL' : 'View SQL'}
      </button>
      {isOpen ? (
        <pre className="m-0 p-3.5 rounded-card border border-navy-500 bg-navy-950 overflow-x-auto b4-thin font-courrier text-ds-125 leading-[1.7] text-navy-100 whitespace-pre-wrap">
          {sql || <span className="text-navy-300">{emptyText}</span>}
        </pre>
      ) : null}
    </div>
  );
};
